          import PxDataService from '@/services/PxDataService'
import * as mutations from './mutation-types'

export default {
  searchCities ({commit}, query) {
    return new Promise((resolve, reject) => {
      PxDataService.searchCities(query).then(response => {
        commit(mutations.ON_RECEIVE_CITIES, {lang: query.lang, cities: response.data.cities})
      }).catch((err) => {
        console.warn(err)
      })
    })
  },
  searchCountries ({commit}, query) {
    return new Promise((resolve, reject) => {
      PxDataService.searchCountries(query).then(response => {
        commit(mutations.ON_RECEIVE_COUNTRIES, {lang: query.lang, countries: response.data.countries})
      }).catch((err) => {
        console.warn(err)
      })
    })
  }
}
